import type { GridAreaSpec } from '@/utils/gridSpec';

import { PageNames } from './pageNames';

/**
 * Template widget structure - defines position, size, and component type
 * without specific data (props, ids, etc.)
 */
export type TemplateWidget = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export enum ScreenRatio {
  Ratio_16_9 = '16_9',
  Ratio_16_10 = '16_10',
  Ratio_24_10 = '24_10',
  Ratio_32_9 = '32_9',
  Other = 'Other',
}

/**
 * Presentation group a template belongs to. Screen ratios collapse into these buckets
 * (16:9 and 16:10 share `Standard`, driven by width); `Video` holds the special camera
 * layouts that are not tied to a single screen shape.
 */
export enum TemplateGroup {
  Standard = 'standard',
  Wide = 'wide',
  Ultrawide = 'ultrawide',
  Video = 'video',
}

/**
 * Layout template - a named, resolution-independent grid described by a {@link GridAreaSpec}.
 * The spec is expanded to fill the current screen when a layout is created, and to a group
 * preview extent for the template icon.
 */
export type LayoutTemplate = {
  description?: string;
  id: string;
  name: string;
  pageName: PageNames;
  group: TemplateGroup;
  spec: GridAreaSpec;
};

export type LayoutTemplatesByGroup = Record<TemplateGroup, LayoutTemplate[]>;
